import { baseURL } from "../../services/api";
import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import { Typography, Button, Image } from "antd";
import "./Tokens.css";
import usd from "../../assets/coinAnimations/usd.webp";
import crypto from "../../assets/coinAnimations/iusd_5_11zon.png";
import {
  baseCEXURL,
  baseDEXURL,
  decodeJWT,
  getUserShortToken,
} from "../../services/api";
import { useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
const { Text } = Typography;

const useStyles = makeStyles((theme: any) => ({
  disclaimerContainer: {
    maxWidth: "1500px",
    margin: "auto",
    padding: "20px",
    marginTop: "100px",
  },
  heading: {
    fontSize: "12px",
    marginBottom: "10px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  subheading: {
    fontSize: "11px",
    marginBottom: "12px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  text: {
    fontSize: "10px",
    lineHeight: "1.5",
    marginBottom: "16px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "10px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  listItem: {
    fontSize: "10px",
    lineHeight: "1.5",
    marginBottom: "6px",
    maxWidth: "1200px",
    color: theme.palette.text.secondary,
  },
  link: {
    textDecoration: "none",
    color: theme.palette.text.secondary,
  },
}));

const IndexxUSD = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [showMore, setShowMore] = useState(false);
  const classes = useStyles();
  const text = `IMPORTANT LEGAL DISCLAIMER Access to products and services detailed 
  on this website may be restricted for certain persons or countries.
  In particular, the products and services referred to herein are not
  available to U.S. Persons, as defined by Regulation S of the United
  States Securities and Exchange Commission, as amended ("U.S.
  Persons"). The information contained on this website is not
  available to U.S. Persons. Investors who are such "U.S. Persons"
  should not view this website. The provision of the information in
  this website does not constitute an offer of securities to any
  person in the United States or to any "U.S. Person." Indexx is not
  registered under the U.S. Investment Company Act of 1940, as
  amended, nor is the sale of Invictus tokens registered under the
  U.S. Securities Act of 1933, as amended. Consequently, it cannot be
  offered for sale or be sold in the United States, its territories,
  possessions or protectorates under its jurisdiction, nor to
  nationals, citizens or residents in any of those areas, except
  pursuant to a valid exemption. More generally, the products and
  services presented on this website may only be purchased in
  jurisdictions in which their marketing and distribution are
  authorized. Indexx advises all interested parties to check in
  advance whether they are legally entitled to purchase the products
  and/or services presented on the website.`;

  const [shortToken, setShortToken] = useState(null);

  useEffect(() => {
    async function checkIsAuthenicated() {
      const isAuthenticated = localStorage.getItem("access_token");
      const email = localStorage.getItem("email");
      let sToken;

      if (email) {
        sToken = await getUserShortToken(email);
        setShortToken(sToken.data);
      } else if (isAuthenticated) {
        let decodedValue: any = await decodeJWT(isAuthenticated);
        sToken = await getUserShortToken(decodedValue?.email);
        setShortToken(sToken.data);
      }
    }
    checkIsAuthenicated();
  }, []);

  const Disclaimer = () => (
    <div className={classes.disclaimerContainer}>
      <h1 className={classes.heading}>indexxusd+(IUSD+) Asset Wallet Disclaimer</h1>
      <p className={classes.text}>
        This indexxusd+(IUSD+) Asset Wallet Disclaimer ("Disclaimer") is issued by <strong>Indexx.ai</strong> (the "Company") and applies to all users ("User" or "You") holding <strong>indexxusd+(IUSD+)</strong> within the Company's platform. By using the Company's asset wallet and holding indexxusd+(IUSD+), you agree to the terms and limitations outlined in this Disclaimer.
      </p>
     
      <h2 className={classes.subheading}>1. indexxusd+(IUSD+) Withdrawal Restrictions</h2>
      <h3 className={classes.subheading}>1.1 Lock-In Period</h3>
      <p className={classes.text}>
        All indexxusd+(IUSD+) held within the Company's platform are <strong>subject to a mandatory lock-in period</strong> until the Company's <strong>Initial Coin Offering (ICO)</strong> or formal <strong>public launch</strong>.<br /><br />
        <ul className={classes.list}>
          <li className={classes.listItem}><strong>During this period, indexxusd+(IUSD+) cannot be withdrawn, sold, exchanged, or converted</strong> into fiat, other cryptocurrencies, or third-party assets.</li>
          <li className={classes.listItem}>This restriction applies <strong>regardless of account status, location, or investment duration</strong>.</li>
        </ul>
      </p>
      <h3 className={classes.subheading}>1.2 INEX Auto-Increment Policy</h3>
      <p className={classes.text}>
        The native INEX token is programmed to <strong>automatically increase in value by $0.25 every quarter</strong> (90-day period) until the Company goes public or launches its ICO. This increment is applied to the internal valuation and reflected across all INEX balances held on the platform.
        <ul className={classes.list}>
          <li className={classes.listItem}>This auto-increment feature is <strong>non-compounding</strong> and is <strong>automated</strong> based on a calendar schedule.</li>
          <li className={classes.listItem}>This policy does not imply or guarantee market liquidity at the incremented value until post-ICO or public launch.</li>
        </ul>
      </p>
      <h3 className={classes.subheading}>1.3 Acknowledgment of Risk</h3>
      <p className={classes.text}>By holding indexxusd+(IUSD+), you acknowledge and accept the following risks:</p>
      <ul className={classes.list}>
        <li className={classes.listItem}><strong>Regulatory Risks:</strong> Legal or policy changes may impact your ability to use or convert indexxusd+(IUSD+) in the future.</li>
        <li className={classes.listItem}><strong>Market Volatility:</strong> Valuations may fluctuate and are not guaranteed.</li>
        <li className={classes.listItem}><strong>Operational Risks:</strong> Technical issues, platform updates, or unforeseen disruptions may impact access to or performance of the asset wallet.</li>
      </ul>
     
      <h2 className={classes.subheading}>2. Limitation of Liability</h2>
      <h3 className={classes.subheading}>2.1 No Guarantee of Value</h3>
      <p className={classes.text}>
        The Company makes <strong>no representations or warranties</strong> regarding the future valuation or liquidity of indexxusd+(IUSD+), including INEX or any other Indexx-issued asset. Market pricing, future listings, or token utility are <strong>not guaranteed</strong>.
      </p>
      <h3 className={classes.subheading}>2.2 Security and Account Responsibility</h3>
      <p className={classes.text}>
        Users are <strong>solely responsible</strong> for maintaining the security and confidentiality of their login credentials and account data.
        <ul className={classes.list}>
          <li className={classes.listItem}>Indexx.ai is <strong>not liable</strong> for any loss resulting from:
            <ul className={classes.list}>
              <li className={classes.listItem}>Unauthorized access</li>
              <li className={classes.listItem}>Account breaches</li>
              <li className={classes.listItem}>User negligence or failure to use available security features</li>
            </ul>
          </li>
        </ul>
      </p>
     
      <h2 className={classes.subheading}>3. Governing Law & Dispute Resolution</h2>
      <ul className={classes.list}>
        <li className={classes.listItem}>This Disclaimer is governed by the <strong>laws of the State of California, United States</strong>.</li>
        <li className={classes.listItem}>Any disputes or claims arising under this Disclaimer shall be resolved through <strong>binding arbitration in California</strong>.</li>
      </ul>
      <ul className={classes.list}>
        <li className={classes.listItem}><strong>Users expressly waive any right to participate in class-action lawsuits</strong> or group arbitration proceedings against Indexx.ai or its affiliates.</li>
      </ul>
     
      <h2 className={classes.subheading}>4. Contact Information</h2>
      <p className={classes.text}>
        For any questions, clarifications, or disputes related to indexxusd+(IUSD+) or this Disclaimer, please contact us at:
      </p>
      <p className={classes.text}><span role="img" aria-label="email">📧</span> <strong>support@indexx.ai</strong><br /><span role="img" aria-label="web">🌐</span> <strong>Indexx.ai</strong><br /><span role="img" aria-label="link">🔗</span> <a href={baseURL} className={classes.link} target="_blank" rel="noopener noreferrer">{baseURL}</a></p>
     
      <p className={classes.text}>
        By continuing to use the Indexx.ai asset wallet and holding any indexxusd+(IUSD+) Token, you confirm that you have <strong>read, understood, and agreed</strong> to the full contents of this Disclaimer and accept all associated terms, risks, and restrictions.
      </p>
    </div>
  );
  
  return (
    <>
      {isMobile ? (
        <div
          className="scan-container how-it-works flex-direction-column text-center "
          style={{ gap: "20px", marginTop: "100px" }}
        >
          <Image
            preview={false}
            src={crypto}
            width={214}
            style={{ marginTop: "20px" }}
          ></Image>

          <div style={{ textAlign: "left", width: "90%" }}>
            <Text strong style={{ fontSize: 50, color: "#1D860A" }}>
              Indexx{" "}
              <span style={{ fontSize: 15, marginTop: 12 }}>&#8482;</span>USD+
            </Text>{" "}
            <br />
            <Text
              style={{
                fontSize: 16,
                color: "var(--body_color)",
              }}
            >
              indexx USD+ stablecoin can be instantly minted and redeemed to
              USDT 1:1.
              <br />
              Simply replace USDT with USD+ stablecoin and start getting passive
              yield where it didn't exist before.
            </Text>
            <br />
            <br />
            <Image preview={false} src={usd} width={"100%"}></Image>
          </div>
          <a
            href={
              shortToken
                ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=IUSD%2B`
                : `${baseCEXURL}/update/home?buyToken=IUSD%2B`
            }
            style={{ width: "90%" }}
          >
            <Button
              type="primary"
              className="thirdButton"
              style={{ marginTop: 20, width: "100%", height: 55 }}
            >
              {" "}
              Buy Tokens
            </Button>
          </a>
          <div className="d-flex flex-column" style={{ width: "90%" }}>
            <Text
              style={{
                marginTop: 80,
                color: "var(--body_color)",
                fontSize: 20,
                textAlign: "left",
              }}
            >
              How Does
            </Text>
            <Text
              style={{
                color: "var(--body_color)",
                fontSize: 35,
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              indexxUSD+ works
            </Text>

            <br />
            <br />
            <Text style={{ textAlign: "left" }}>
              <p style={{ fontSize: 20, color: "var(--body_color)" }}>
                <strong>
                  indexx USD+ includes 3 <br /> components:
                </strong>
              </p>
              <br />

              <div
                style={{
                  fontSize: 22,
                  color: "var(--body_color)",
                }}
              >
                <p>
                  <b>1. PEGGED TO USDT 1 : 1 </b>
                </p>
                <ul style={{ fontSize: 16, listStyleType: "disc" }}>
                  <li>
                    100% collateralized with assets immediately convertable into
                    USDT
                  </li>
                  <li>
                    &apos;Risk-first portfolio&apos;, i.e. assets are picked
                    primarily to avoid losses on a daily basis
                  </li>
                </ul>
                <p style={{ fontSize: 16 }}>
                  &nbsp; &nbsp; &nbsp; (3-4 sigmas away from 0), no exposure to
                  algorithmic stables
                </p>
                <ul style={{ fontSize: 16, listStyleType: "disc" }}>
                  <li>USD+ can replace USDT in pools and lending protocols</li>
                </ul>
                <p>
                  <br />
                </p>
              </div>
              <div
                style={{
                  fontSize: 22,
                  color: "var(--body_color)",
                }}
              >
                <p>
                  <b>2. YIELD GENERATING</b>
                </p>
                <ul style={{ fontSize: 16, listStyleType: "disc" }}>
                  <li>
                    Collateral consists of yield-bearing strategies, including
                    lending and stable-to-stable pools
                  </li>
                  <li>
                    Portfolio allocation decentrally controlled (community
                    proposals, veto power by token stakers/insurance providers)
                  </li>
                  <li>
                    Portfolio strategy executed decentrally via smart-contracts
                  </li>
                  <li>Profit paid out daily in indexxUSD+ via rebase</li>
                </ul>
                <p>&nbsp;</p>
              </div>
              <div
                style={{
                  fontSize: 22,
                  color: "var(--body_color)",
                }}
              >
                <p>
                  <b>3. INSURANCE</b>
                </p>
                <ul style={{ fontSize: 16, listStyleType: "disc" }}>
                  <li>Coming soon</li>
                </ul>
              </div>
            </Text>
            <a
              href={
                shortToken
                  ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=IUSD%2B`
                  : `${baseCEXURL}/update/home?buyToken=IUSD%2B`
              }
              style={{ width: "90%" }}
            >
              <Button
                type="primary"
                className="thirdButton"
                style={{ marginTop: 40, height: 55, width: "100%" }}
              >
                {" "}
                Buy Tokens
              </Button>
            </a>

            <br />
            <br />
            <br />
            <br />
            <br />

            <Text
              style={{
                color: "var(--body_color)",
                textAlign: "left",
              }}
            >
              {showMore ? text : `${text.substring(0, 250)}`}
              <button className="show-m" onClick={() => setShowMore(!showMore)}>
                {showMore ? "Read less" : "Read more"}
              </button>
            </Text>
          </div>
        </div>
      ) : (
        <div className="scan-container how-it-works flex-direction-column text-center ">
          <Image preview={false} src={usd} width={1000}></Image>
          <Image
            preview={false}
            src={crypto}
            width={130}
            style={{ marginTop: "20px" }}
          ></Image>

          <div style={{ textAlign: "left", marginTop: 60 }}>
            <Text strong style={{ fontSize: 65, color: "#1D860A" }}>
              Indexx{" "}
              <span style={{ fontSize: 15, marginTop: 12 }}>&#8482;</span>USD+
            </Text>{" "}
            <br />
            <Text
              style={{
                fontSize: 22,
                opacity: "70%",
                color: "var(--body_color)",
              }}
            >
              indexx USD+ stablecoin can be instantly minted and redeemed to
              USDT 1:1.
              <br />
              Simply replace USDT with USD+ stablecoin and start getting passive
              yield where it didn't exist before.
            </Text>
            <br />
            <br />
          </div>
          <a
            href={
              shortToken
                ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=IUSD%2B`
                : `${baseCEXURL}/update/home?buyToken=IUSD%2B`
            }
          >
            <Button
              type="primary"
              shape="round"
              className="thirdButton"
              style={{ marginTop: 20 }}
            >
              {" "}
              Buy Tokens
            </Button>
          </a>
          <Text
            style={{
              marginTop: 80,
              opacity: "60%",
              color: "var(--body_color)",
              fontSize: 65,
            }}
          >
            How Does indexxUSD+ works
          </Text>
          <br />
          <br />
          <br />
          <Text
            style={{ textAlign: "left", paddingLeft: 100, paddingRight: 100 }}
          >
            <p style={{ fontSize: 22, color: "var(--body_color)" }}>
              <strong>indexx USD+ includes 3 components:</strong>
            </p>
            <br />

            <div
              style={{
                fontSize: 22,
                opacity: "70%",
                color: "var(--body_color)",
              }}
            >
              <p>1. PEGGED TO USDT 1 : 1</p>
              <ul>
                <li>
                  100% collateralized with assets immediately convertable into
                  USDT
                </li>
                <li>
                  &apos;Risk-first portfolio&apos;, i.e. assets are picked
                  primarily to avoid losses on a daily basis
                </li>
              </ul>
              <p>
                &nbsp; &nbsp; &nbsp; (3-4 sigmas away from 0), no exposure to
                algorithmic stables
              </p>
              <ul>
                <li>USD+ can replace USDT in pools and lending protocols</li>
              </ul>
              <p>
                <br />
              </p>
            </div>
            <div
              style={{
                fontSize: 22,
                opacity: "70%",
                color: "var(--body_color)",
              }}
            >
              <p>2. YIELD GENERATING</p>
              <ul>
                <li>
                  Collateral consists of yield-bearing strategies, including
                  lending and stable-to-stable pools
                </li>
                <li>
                  Portfolio allocation decentrally controlled (community
                  proposals, veto power by token stakers/insurance providers)
                </li>
                <li>
                  Portfolio strategy executed decentrally via smart-contracts
                </li>
                <li>Profit paid out daily in indexxUSD+ via rebase</li>
              </ul>
              <p>&nbsp;</p>
            </div>
            <div
              style={{
                fontSize: 22,
                opacity: "70%",
                color: "var(--body_color)",
              }}
            >
              <p>3. INSURANCE</p>
              <ul>
                <li>Coming soon</li>
              </ul>
            </div>
          </Text>
          <a
            href={
              shortToken
                ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=IUSD%2B`
                : `${baseCEXURL}/update/home?buyToken=IUSD%2B`
            }
            style={{ width: "90%" }}
          >
            <Button
              type="primary"
              shape="round"
              className="thirdButton"
              style={{ marginTop: 40 }}
            >
              {" "}
              Buy Tokens
            </Button>
          </a>
          <br />
          <br />
          <br />
          <br />
          <br />

          <Text
            style={{
              opacity: "70%",
              color: "var(--body_color)",
              textAlign: "left",
              paddingLeft: 100,
              paddingRight: 100,
            }}
          >
            IMPORTANT LEGAL DISCLAIMER Access to products and services detailed
            on this website may be restricted for certain persons or countries.
            In particular, the products and services referred to herein are not
            available to U.S. Persons, as defined by Regulation S of the United
            States Securities and Exchange Commission, as amended (“U.S.
            Persons”). The information contained on this website is not
            available to U.S. Persons. Investors who are such "U.S. Persons"
            should not view this website. The provision of the information in
            this website does not constitute an offer of securities to any
            person in the United States or to any "U.S. Person." Indexx is not
            registered under the U.S. Investment Company Act of 1940, as
            amended, nor is the sale of Invictus tokens registered under the
            U.S. Securities Act of 1933, as amended. Consequently, it cannot be
            offered for sale or be sold in the United States, its territories,
            possessions or protectorates under its jurisdiction, nor to
            nationals, citizens or residents in any of those areas, except
            pursuant to a valid exemption. More generally, the products and
            services presented on this website may only be purchased in
            jurisdictions in which their marketing and distribution are
            authorized. Indexx advises all interested parties to check in
            advance whether they are legally entitled to purchase the products
            and/or services presented on the website.
          </Text>
        </div>
      )}
      <div style={{ marginTop: 300 }}></div>
      <Disclaimer />
      <Footer />
    </>
  );
};

export default IndexxUSD;
